import { formatToLocalizedCurrency } from "../../util/currency/currency.js";
import { PricingInfoList } from "../pricing-info/PricingInfoList.js";
import { HeaderGroup } from "./internal/HeaderGroup.js";
import { Trans, useTranslation } from "react-i18next";
import { BadgeList, Body1, Box, ElevatedCard, IconControlledSubstance, Stack, Subtitle3 } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/alternative-card/AlternativeCard.tsx
/**
*   Displays cost-effective medication alternatives available for the patient's prescription
*/
const AlternativeCard = ({ product: { name, description }, pricing, role, patientSavings, planSavings, onClick, isControlledSubstance, pharmacyName, badges = [] }) => {
	const { t } = useTranslation("phx-lib");
	if (patientSavings && patientSavings > 1) badges.push({
		label: t("alternatives.saveTag", { amount: formatToLocalizedCurrency(patientSavings) }),
		color: "success"
	});
	if (planSavings && planSavings >= 20) badges.push({
		label: t("alternatives.planSaveTag", { amount: formatToLocalizedCurrency(planSavings) }),
		color: "info"
	});
	return /* @__PURE__ */ jsx(ElevatedCard, {
		header: /* @__PURE__ */ jsx(BadgeList, { badgelist: badges }),
		role,
		onClick,
		children: /* @__PURE__ */ jsxs(Stack, {
			gap: "sm",
			children: [
				/* @__PURE__ */ jsx(HeaderGroup, {
					title: name,
					description,
					icon: isControlledSubstance ? /* @__PURE__ */ jsx(IconControlledSubstance, {}) : void 0
				}),
				pricing ? /* @__PURE__ */ jsx(PricingInfoList, { pricing }) : null,
				pharmacyName ? /* @__PURE__ */ jsx(Trans, {
					i18nKey: "alternatives.pricesAt",
					values: { pharmacyName },
					children: /* @__PURE__ */ jsxs(Box, {
						display: "inline",
						ta: "right",
						children: [/* @__PURE__ */ jsx(Body1, {
							inline: true,
							children: "Prices at "
						}), /* @__PURE__ */ jsx(Subtitle3, {
							inline: true,
							children: pharmacyName
						})]
					})
				}) : null
			]
		})
	});
};

//#endregion
export { AlternativeCard };